import React from 'react';
import styles from './chatbot.module.scss';

const ChatConversationModal = ({
    modalConfig,
    renameInput,
    onRenameInputChange,
    onClose,
    onRenameConfirm,
    onDeleteConfirm
}) => {
    if (!modalConfig.isOpen) {
        return null;
    }

    return (
        <div className={styles.modalOverlay}>
            <div className={styles.modalContent}>
                <div className={styles.modalHeader}>
                    {modalConfig.type === 'rename' ? 'Rename Conversation' : 'Delete Conversation'}
                </div>
                <div className={styles.modalBody}>
                    {modalConfig.type === 'rename' ? (
                        <input
                            type="text"
                            value={renameInput}
                            onChange={(event) => onRenameInputChange(event.target.value)}
                            autoFocus
                            onKeyPress={(event) => {
                                if (event.key === 'Enter') {
                                    onRenameConfirm();
                                }
                            }}
                        />
                    ) : (
                        <p>Are you sure you want to delete this conversation?</p>
                    )}
                </div>
                <div className={styles.modalFooter}>
                    <button onClick={onClose} className={styles.cancelBtn}>Cancel</button>
                    {modalConfig.type === 'rename' ? (
                        <button onClick={onRenameConfirm} className={styles.confirmBtn}>Rename</button>
                    ) : (
                        <button onClick={onDeleteConfirm} className={styles.deleteBtn}>Delete</button>
                    )}
                </div>
            </div>
        </div>
    );
};

export default ChatConversationModal;